var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterBoiler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 2.4165C8.32542 2.4165 7.25 3.49192 7.25 4.83317V19.3332C7.25 20.6744 8.32542 21.7498 9.66667 21.7498H10.875V24.1665H7.25V26.5832H10.875C12.2162 26.5832 13.2917 25.5078 13.2917 24.1665V21.7498H15.7083V24.1665C15.7083 25.5078 16.7838 26.5832 18.125 26.5832H21.75V24.1665H18.125V21.7498H19.3333C20.6746 21.7498 21.75 20.6744 21.75 19.3332V4.83317C21.75 3.49192 20.6746 2.4165 19.3333 2.4165H9.66667ZM14.5 6.00525C15.1409 6.00525 15.7556 6.25987 16.2088 6.71308C16.6621 7.16629 16.9167 7.78098 16.9167 8.42192C16.9167 9.06286 16.6621 9.67755 16.2088 10.1308C15.7556 10.584 15.1409 10.8386 14.5 10.8386C13.8591 10.8386 13.2444 10.584 12.7912 10.1308C12.3379 9.67755 12.0833 9.06286 12.0833 8.42192C12.0833 7.78098 12.3379 7.16629 12.7912 6.71308C13.2444 6.25987 13.8591 6.00525 14.5 6.00525ZM12.0833 17.5207H16.9167V19.3332H12.0833V17.5207Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBoiler);
export default __webpack_public_path__ + "static/media/water-boiler.1f7c7f31fde7cc53111f1b86abee94a6.svg";
export { ForwardRef as ReactComponent };